"use client"
import BaseDetailsDrawer from "./BaseDetailsDrawer"
import { getBookingDetail } from "../../../Controllers/BookingManagement"
import { __constants, __snackBarSeverity, __snackBarText } from "../../../constants"
import moment from "moment"
import JobInvoice from "./JobInvoice"
import Button from "@mui/material/Button"
import Tags from "../../../common_components/Tags"
import Divider from "@mui/material/Divider"

const BookingDetails = ({ canvasState, setCanvasState }) => {
  const config = {
    drawerTitle: "Booking details",
    fetchDetails: getBookingDetail,
    getId: (canvasState) => canvasState.applicationId,
    InvoiceComponent: JobInvoice,
    snackBarSeverity: __snackBarSeverity,
    snackBarText: __snackBarText,

    getProfileData: (data) => ({
      profilePicture: `${__constants.images}${data?.applicationDetail?.profilePicture || ""}`,
      name: `${data?.applicationDetail?.firstName} ${data?.applicationDetail?.lastName}`,
      reviews: {
        average: data?.applicationDetail?.review?.avg || 0,
        count: data?.applicationDetail?.review?.count || 0,
      },
      about: data?.applicationDetail?.aboutMe,
      children:
        data?.applicationDetail?.role === "BabySitter"
          ? `${data?.applicationDetail?.childrens?.length || 0} ${data?.applicationDetail?.childrens?.length > 1 ? "Children" : "Child"}${
              data?.applicationDetail?.childrens?.length > 0 &&
              data?.applicationDetail?.childrens[0].hasOwnProperty("dateOfBirth")
                ? ` - ${
                    data?.applicationDetail?.childrens
                      ?.map((item) => moment(item?.dateOfBirth).toNow(true)?.split(" ")[0] || " ")
                      .join(", ")
                      .replace(
                        new RegExp(
                          `, ${
                            moment(
                              data?.applicationDetail?.childrens[data?.applicationDetail?.childrens.length - 1]
                                ?.dateOfBirth,
                            )
                              .toNow(true)
                              ?.split(" ")[0]
                          }$`,
                        ),
                        ` & ${
                          moment(
                            data?.applicationDetail?.childrens[data?.applicationDetail?.childrens.length - 1]
                              ?.dateOfBirth,
                          )
                            .toNow(true)
                            ?.split(" ")[0]
                        }`,
                      ) || ""
                  } year old`.replace("a year", "1 year")
                : ""
            }`
          : null,
    }),

    getRole: (data) => data?.applicationDetail?.role,

    getAvailability: (data) => data?.applicationDetail?.availability || [],

    getInvoiceId: (data) => data?.applicationDetail?._id,

    getTagsSection: (data, themeClass) => null,

    getDetailsSection: (data, themeClass) => (
      <>
        <div style={{ display: "flex" }}>
          <strong className={themeClass}>Area</strong>
          <div>
            {data?.applicationDetail?.jobAddress || " - "}, {data?.applicationDetail?.jobArea || " - "},{" "}
            {data?.applicationDetail?.jobCity || " - "}
          </div>
        </div>

        <Divider className="divider-gap" />

        {data?.applicationDetail?.role === "HouseKeeper" && (
          <>
            <div style={{ display: "grid", rowGap: "0.5rem" }}>
              <strong className={themeClass}>Help with</strong>
              <div>
                {data?.applicationDetail?.helpWith &&
                  data?.applicationDetail?.helpWith.map((obj, index) => (
                    <Tags key={index} title={obj.name} isActive={true} />
                  ))}
                {data?.applicationDetail?.helpWith &&
                  data?.applicationDetail?.helpWith.length === 0 &&
                  "Data Not available"}
              </div>
            </div>
            <Divider className="divider-gap" />
          </>
        )}

        <div style={{ display: "grid", rowGap: "0.5rem" }}>
          <strong className={themeClass}>Preferred Languages</strong>
          {data?.applicationDetail?.preferredLanguages?.length > 0
            ? data.applicationDetail.preferredLanguages.join(", ")
            : "No preferred languages"}
        </div>

        <Divider className="divider-gap" />
        <div style={{ display: "grid", rowGap: "0.5rem" }}>
          <strong className={themeClass}>Needs</strong>
          {data?.applicationDetail?.myNeed?.length > 0
            ? data.applicationDetail.myNeed.join(", ")
            : "No Needs are available."}
        </div>

        <Divider className="divider-gap" />
        <div style={{ display: "grid", rowGap: "0.5rem" }}>
          <strong className={themeClass}>Job description</strong>
          {data?.applicationDetail?.jobDescription || "Job description not available"}
        </div>

        <Divider className="divider-gap" />

        {data?.applicationDetail?.role === "BabySitter" ? (
          <>
            <div style={{ display: "flex", margin: "10px 0" }}>
              <div>Total hours- day</div>
              <div>{data?.billDetail?.totalHours - data?.billDetail?.totalOvernightHour} hrs</div>
            </div>
            <div style={{ display: "flex", margin: "10px 0" }}>
              <div>Total hours- overnight</div>
              <div>{data?.billDetail?.totalOvernightHour} hrs</div>
            </div>
            <div style={{ display: "flex", margin: "10px 0" }}>
              <div>Day rate per hours</div>
              <div>{data?.billDetail?.hourlyRate} hrs</div>
            </div>
            <div style={{ display: "flex", margin: "10px 0" }}>
              <div>Overnight rate per hours</div>
              <div>{data?.billDetail?.overnightRate} hrs</div>
            </div>
          </>
        ) : (
          <>
            <div style={{ display: "flex", margin: "10px 0" }}>
              <div>Total hours</div>
              <div>{data?.billDetail?.totalHours - data?.billDetail?.totalOvernightHour} hrs</div>
            </div>
            <div style={{ display: "flex", margin: "10px 0" }}>
              <div>rate per hours</div>
              <div>{data?.billDetail?.hourlyRate} hrs</div>
            </div>
          </>
        )}

        <Divider className="divider-gap" />

        {data?.applicationDetail?.reasonSeekerCancelled && (
          <>
            <div style={{ display: "grid", rowGap: "0.5rem" }}>
              <strong className={themeClass}>Reason for cancellation by seeker</strong>
              {data.applicationDetail.reasonSeekerCancelled}
            </div>
            <Divider className="divider-gap" />
          </>
        )}
        {data?.applicationDetail?.reasonProviderCancelled && (
          <>
            <div style={{ display: "grid", rowGap: "0.5rem" }}>
              <strong className={themeClass}>Reason for cancellation by provider</strong>
              {data.applicationDetail.reasonProviderCancelled}
            </div>
            <Divider className="divider-gap" />
          </>
        )}
        {data?.applicationDetail?.reasonSeekerDeclined && (
          <>
            <div style={{ display: "grid", rowGap: "0.5rem" }}>
              <strong className={themeClass}>Reason for decline by seeker</strong>
              {data.applicationDetail.reasonSeekerDeclined}
            </div>
            <Divider className="divider-gap" />
          </>
        )}
        {data?.applicationDetail?.reasonProviderDeclined && (
          <>
            <div style={{ display: "grid", rowGap: "0.5rem" }}>
              <strong className={themeClass}>Reason for decline by provider</strong>
              {data.applicationDetail.reasonProviderDeclined}
            </div>
            <Divider className="divider-gap" />
          </>
        )}
      </>
    ),

    getActionButtons: (data, canvasState, handleInvoice) =>
      canvasState?.haveInvoice && (
        <div>
          <Button variant="contained" size="small" sx={{ mt: 3, textTransform: "unset" }} onClick={handleInvoice}>
            View invoice
          </Button>
        </div>
      ),
  }

  return <BaseDetailsDrawer canvasState={canvasState} setCanvasState={setCanvasState} config={config} />
}

export default BookingDetails
